import { useQuery } from 'react-query';
import AIInteractionAPI from 'services/API/AIInteractionAPI';

export const useGenerateProjectDetails = ({
  projectSlug,
  documentId,
}: {
  projectSlug?: string;
  documentId?: string;
}) => {
  return useQuery(
    ['generate-details-ai', projectSlug, documentId],
    async () => {
      let result;
      if (documentId) {
        result = await AIInteractionAPI.postGenerateDocumentDetails({
          documentId,
        });
      } else if (projectSlug) {
        result = await AIInteractionAPI.postGenerateProjectDetails({
          projectSlug,
        });
      }

      return result?.data;
    },
    {
      enabled: !!projectSlug || !!documentId,
      refetchOnWindowFocus: false,
    },
  );
};
